import { initAnimations } from './animationer.js'

export default () => {
    const loadmoreBtns = document.querySelectorAll('.results__category__bottom__btn');
    const query = document.querySelector('#query').value;

    if(loadmoreBtns.length > 0) {
        loadmoreBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                const text = btn.innerHTML;
                const type = btn.dataset.type;
                const page = parseInt(btn.dataset.page) + 1;
                const cl = btn.dataset.class;
                const perLoad = parseInt(btn.dataset.perload);
                const totalHits = parseInt(btn.dataset.hits);
                const postContainer = document.querySelector('.results__category__posts.' + type);

                btn.innerHTML = "Laddar...";

                $.post(
                    horizon.ajaxUrl,
                    {
                        action: 'nobox_load_more_results',
                        type: type,
                        class: cl,
                        query: query,
                        page: page,
                        perLoad: perLoad,
                    },
                    (data, response) => {
                        if (response === 'success') {
                            postContainer.innerHTML += data.html;

                            initAnimations();

                            btn.dataset.page = page;
                            btn.innerHTML = text;

                            if(perLoad*page >= totalHits) {
                                btn.style.display = 'none';
                            }
                        }
                    }
                );
            });
        });
    }
};
